module.exports = __webpack_public_path__ + "static/developing_code-11e7ad37bfbd2cd30450a497b541aa49.svg";